var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "#EFEFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features #06 [Desktop] - Customer Support",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3067,
    transform: "translate(-1064 -47.7444)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hero"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 982,
    transform: "translate(-1064 -47.7444)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Header / Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "div.main-navbar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "div.dropdown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    opacity: 0.35,
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.41211 3.77124L5.16602 7.01733L1.9082 3.77124L0.830078 4.84937L5.1543 9.39624L9.49023 4.84937L8.41211 3.77124Z",
    fill: "black"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 3067,
    fill: "white",
    transform: "translate(-1064 -47.7444)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.830078 12.2556)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowGrey);
export default __webpack_public_path__ + "static/media/down-arrow-grey.7e44769945a58dfccb590f6a54b5147e.svg";
export { ForwardRef as ReactComponent };